import React, { useReducer, useContext, useEffect, useState } from "react";
import AppContext from "./appContext";
import toast, { Toaster } from 'react-hot-toast';
import { showCartAddError } from "../utils/cart-add-toast";

const intialState = {
  is_preview_mode: true, // It will be false for shopify preview mode  
  activeStep: 0,
  popUpType: null,
  extensionSurface: null,
  /** "widget" = Essential-style offer only (no page chrome) */
  previewChrome: null,
  user: null,
  shop: {},
  popupValue: [],
  spinwheel_code:'',
};

const appReducer = (state, action) => {
  switch (action.type) {
    case "STORE_INIT":
      return { ...state, ...action.payload };
    case "POPUP_INIT":
      return { ...state, ...action.payload };
    case "SPIN_WHEEL":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export const AppProvider = ({ children, prevState }) => {
  const [appState, dispatch] = useReducer(appReducer, prevState || intialState);
  const [upsellData,setUpsellData]= useState();
  const [popupGlobalData, setPopupGlobalData]= useState({});
  const [addToCartEvents, setAddToCartEvents]= useState(null)
  const [cartOpen, setCartOpen] = useState(false);
  const [cartData, setCartData] = useState(null);
  const [clickTriggerEvents, setClickTriggerEvents]= useState({})
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(max-width:768px)").matches;
  });
  const [isSmallMobile, setIsSmallMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(max-width:425px)").matches;
  });

  /** Editor toolbar desktop/mobile — overrides viewport when is_preview_mode. */
  const [previewDeviceIsMobile, setPreviewDeviceIsMobile] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;

    const mobileMq = window.matchMedia("(max-width:768px)");
    const smallMobileMq = window.matchMedia("(max-width:425px)");

    const updateMatches = () => {
      setIsMobile(mobileMq.matches);
      setIsSmallMobile(smallMobileMq.matches);
    };

    updateMatches();
    mobileMq.addEventListener("change", updateMatches);
    smallMobileMq.addEventListener("change", updateMatches);

    return () => {
      mobileMq.removeEventListener("change", updateMatches);
      smallMobileMq.removeEventListener("change", updateMatches);
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    window.__WEUPSELL_SHOW_CART_ADD_ERROR__ = showCartAddError;
    return () => {
      delete window.__WEUPSELL_SHOW_CART_ADD_ERROR__;
    };
  }, []);

  return (
    <AppContext.Provider
      value={{
        appState,
        dispatch,
        isMobile,
        isSmallMobile,
        previewDeviceIsMobile,
        setPreviewDeviceIsMobile,
        upsellData,
        setUpsellData,
        toast,
        setAddToCartEvents,
        addToCartEvents,
        clickTriggerEvents,
        setClickTriggerEvents,
        popupGlobalData,
        setPopupGlobalData,
        cartOpen,
        setCartOpen,
        setCartData,
        cartData,
      }}
    >
      {children}
      {/* Keep for non-cart toast.error/success callers; cart add uses styled DOM toast. */}
      <Toaster
        position="top-center"
        containerStyle={{ zIndex: 2147483647 }}
        toastOptions={{
          duration: 4000,
          style: {
            zIndex: 2147483647,
            background: "#111827",
            color: "#fff",
            borderRadius: "10px",
            padding: "12px 14px",
            fontSize: "14px",
            fontWeight: 500,
            boxShadow: "0 10px 30px rgba(15, 23, 42, 0.18)",
          },
          error: {
            style: {
              background: "#dc2626",
              color: "#fff",
            },
          },
          success: {
            style: {
              background: "#16a34a",
              color: "#fff",
            },
          },
        }}
      />
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

export default AppContext;